import { createBrowserRouter, Navigate } from "react-router-dom";
import HomePageLayout from "../Layouts/HomePageLayout/HomePage.layout";
import HomePage from "../Pages/Home/Home";
import PropertyPageLayout from "../Layouts/PropertyPageLayout/PropertyPageLayout";
import PropertyDetailPage from "../Pages/PropertyDetailPage/PropertyDetailPage";
import FeaturePage from "../Pages/Features/Features";
import ResourcePage from "../Pages/Resources/Resources";
import PremiumPage from "../Pages/Premium/Premium";
import PremiumWelcome from "../Pages/Premium/PremiumWelcome";
import PropertyProfessionalPage from "../Pages/PropertyProfessional/PropertyProfessional";
import APP_ROUTES from "./APP_ROUTES";
import VVNEW from "../Pages/ValidatePropertyPageNew/ValidatePropertyPageNew";
import CollectionListing from "../Pages/PropertyCollectionList/PropertyCollectionList";
import WhySimplerHome from "../Pages/WhySimplerHome/WhySimplerHome";
import MessageFromTeam from "../Pages/MessageFromTeam/MessageFromTeam";
import HomeMaintenanceGuide from "../Pages/HomeMaintenanceGuide/HomeMaintenanceGuide";
import Careers from "../Pages/Careers/Careers";
import Contact from "../Pages/Contact/Contact";
import Press from "../Pages/Press/Press";
import Blog from "../Pages/Blog/Blog";
import TermsPrivacy from "../Pages/TermsPrivacy/TermsPrivacy";
import DoNotSell from "../Pages/DoNotSell/DoNotSell";
import Legal from "../Pages/Legal/Legal";
import TrueCostGuide from "../Pages/TrueCostGuide/TrueCostGuide";
import LicensingRequirements from "../Pages/LicensingRequirements/LicensingRequirements";
import StateList from "../Pages/StateList/StateList";
import CityList from "../Pages/CityList/CityList";
import MyAccount from "../Pages/MyAccount/MyAccount";
import HomeHistory from "../Pages/HomeHistory/HomeHistory";
import AdminLayout from "../Layouts/AdminLayout/AdminLayout";
import AdminLoginPage from "../admin/pages/Login/Login";
import ResponsiveLayout from "../Layouts/ResponsiveLayout/ResponsiveLayout";
import AdminDashboardPage from "../admin/pages/AdminDashboardPage/AdminDashboardPage";
import APNUploadPage from "../admin/pages/APNUploadPage/APNUploadPage";
import ResetPassword from "../Pages/ResetPassword/ResetPassword";
import ThankYouPage from "../Pages/ThankYou/ThankYou";
import WishlistPage from "../Pages/Wishlist/Wishlist";
import VendorRegisterRedirect from "../Pages/VendorRegister/VendorRegisterRedirect";
import NotFoundPage from "../Pages/NotFound/NotFound";
import RouteError from "../Pages/RouteError/RouteError";

function RequireAuth({ children, redirectTo }: any) {
  let isAuthenticated = true;
  return isAuthenticated ? children : <Navigate to={redirectTo} />;
}

export const appRouter = createBrowserRouter([
  {
    element: <HomePageLayout />,
    errorElement: <RouteError />,
    children: [
      {
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "/thank-you",
        element: <ThankYouPage />,
      },
      {
        // The vendor portal lives at vendor.simplerhome.us — this only
        // redirects, since /vendor/register already shipped publicly here.
        path: "/vendor/register",
        element: <VendorRegisterRedirect />,
      },
      {
        path: "/",
        element: (
          <RequireAuth redirectTo="#login">
            <HomePage />
          </RequireAuth>
        ),
      },
      {
        path: String(APP_ROUTES.FEATURE.pathname),
        element: (
          <RequireAuth redirectTo="#login">
            <FeaturePage />
          </RequireAuth>
        ),
      },
      {
        path: String(APP_ROUTES.RESOURCES.pathname),
        element: (
          <RequireAuth redirectTo="#login">
            <ResourcePage />
          </RequireAuth>
        ),
      },
      {
        path: String(APP_ROUTES.PREMIUM.pathname),
        element: (
          <RequireAuth redirectTo="#login">
            <PremiumPage />
          </RequireAuth>
        ),
      },
      {
        // Stripe Checkout success lands here (success_url). Confirms the plan.
        path: "/premium/welcome",
        element: <PremiumWelcome />,
      },

      {
        path: String(APP_ROUTES.PROPERTY_PROFESSIONAL.pathname),
        element: (
          <RequireAuth redirectTo="#login">
            <PropertyProfessionalPage />
          </RequireAuth>
        ),
      },

      {
        path: String(`:query/property-id/:searchQuery`),
        element: <VVNEW />,
      },
      {
        path: String(`:query/state/:searchQuery`),
        element: <CollectionListing />,
      },

      {
        path: String(`:query/city/:searchQuery`),
        element: <CollectionListing />,
      },

      {
        path: String(`:query/county/:searchQuery`),
        element: <CollectionListing />,
      },

      {
        path: String(`:query/neighborhood_id/:searchQuery`),
        element: <CollectionListing />,
      },

      {
        path: String(`:query/zip/:searchQuery`),
        element: <CollectionListing />,
      },
      {
        path: String(APP_ROUTES.WHY_SIMPLER_HOME.pathname),
        element: <WhySimplerHome />,
      },
      {
        path: String(APP_ROUTES.MESSAGE_FROM_TEAM.pathname),
        element: <MessageFromTeam />,
      },
      {
        path: String(APP_ROUTES.HOME_MAINTENANCE_GUIDE.pathname),
        element: <HomeMaintenanceGuide />,
      },
      {
        path: String(APP_ROUTES.CAREERS.pathname),
        element: <Careers />,
      },
      {
        path: String(APP_ROUTES.CONTACT.pathname),
        element: <Contact />,
      },
      {
        path: String(APP_ROUTES.PRESS.pathname),
        element: <Press />,
      },
      {
        path: String(APP_ROUTES.BLOG.pathname),
        element: <Blog />,
      },
      {
        path: String(APP_ROUTES.TERMS_PRIVACY.pathname),
        element: <TermsPrivacy />,
      },
      {
        path: String(APP_ROUTES.DO_NOT_SELL.pathname),
        element: <DoNotSell />,
      },
      {
        path: String(APP_ROUTES.LEGAL.pathname),
        element: <Legal />,
      },
      {
        path: String(APP_ROUTES.TRUE_COST_GUIDE.pathname),
        element: <TrueCostGuide />,
      },
      {
        path: String(APP_ROUTES.LICENSING_REQUIREMENTS.pathname),
        element: <LicensingRequirements />,
      },
      {
        path: String(APP_ROUTES.BROWSE_STATES.pathname),
        element: <StateList />,
      },
      {
        path: String(APP_ROUTES.BROWSE_CITIES.pathname),
        element: <CityList />,
      },
      {
        path: "/wishlist",
        element: <WishlistPage />,
      },
      {
        path: String(APP_ROUTES.MY_ACCOUNT.pathname),
        element: <MyAccount />,
      },
      {
        path: String(APP_ROUTES.HOME_HISTORY.pathname),
        element: (
          <RequireAuth redirectTo="#login">
            <HomeHistory />
          </RequireAuth>
        ),
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
  {
    element: <PropertyPageLayout />,
    errorElement: <RouteError />,
    children: [
      {
        path: "/property-details",
        element: (
          <RequireAuth redirectTo="#login">
            <PropertyDetailPage />
          </RequireAuth>
        ),
      },
    ],
  },
  {
    element: <ResponsiveLayout />,
    errorElement: <RouteError />,
    children: [
      {
        path: "/admin/login",
        element: <AdminLoginPage />,
      },
    ],
  },
  {
    element: <AdminLayout />,
    errorElement: <RouteError />,
    children: [
      {
        path: APP_ROUTES.ADMIN_DASHBOARD.pathname.toString(),
        element: <AdminDashboardPage />,
      },
      {
        path: APP_ROUTES.ADMIN_APN_UPLOAD.pathname.toString(),
        element: <APNUploadPage />,
      },
    ],
  },
]);
